import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log error info here if needed.
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    // If the error is a ChunkLoadError, reload the page to fetch fresh assets.
    if (error && (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk'))) {
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI: show a message prompting user to refresh.
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Something went wrong.</h2>
        <p>An error occurred while loading the page. Please click the button below to reload.</p>
        <button 
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            cursor: 'pointer',
            marginTop: '20px'
          }}
          onClick={() => window.location.reload()}
        >
          Reload Page
        </button>
      </div>
    );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
